import { cropArray } from '../../Data/CropsData';
import Image from 'next/image';
import { motion } from 'framer-motion';
import MetaHead from '@/Components/MetaHead';

import ContentText from '@/Components/ContentText';
import ContentTitle from '@/Components/ContentTitle';

export default function CropId({ Crop, id }) {
  return (
    <div className="h-full w-full ">
      <MetaHead title={Crop.title + ' | Fyllo'} />
      <section className="text-gray-700 body-font overflow-hidden p-5 ">
        <div className="container px-0 py-12 mx-auto max-w-screen-xl">
          <div className="w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-24 place-items-center">
            <Image
              priority
              alt={Crop?.text}
              // className="w-full border-4 rounded-lg"
              height={200}
              width={200}
              className="shadow-lg rounded w-[90%] h-auto align-middle  self-center hover:scale-110 transition-all ease-in-out delay-150 duration-300  hover:rounded-2xl"
              src={Crop?.image?.png}
              sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
            />
            <div className=" w-full lg:py-6 mt-6 lg:mt-0">
              <h3 className=" mb-2 md:mb-6 text-xl md:text-4xl font-semibold tracking-tight text-green-800">
                {Crop?.title}
              </h3>
              <p className="mb-3 text-xs md:text-lg font-normal text-gray-700">{Crop?.description}</p>
            </div>
          </div>
        </div>
        <div className="container mx-auto max-w-screen-xl">
          <h3 className="text-2xl md:text-[3rem] text-fyllo-800 font-bold flex flex-col py-4 my-8 md:pb-20   text-left capitalize">
            {Crop?.subHeading}
          </h3>

          <div className="w-full flex flex-col gap-8">
            {Crop?.points?.map((point, i) => {
              return (
                <div
                  key={i}
                  className={
                    'w-full flex items-center rounded-lg md:px-10 flex-col ' +
                    (i % 2 === 1 ? 'md:flex-row ' : 'md:flex-row-reverse')
                  }
                >
                  <div
                    className={'w-full md:w-1/2 h-auto leading-normal text-start  ' + (i >= 6 ? 'md:flex-grow' : '')}
                  >
                    <motion.div
                      initial={{
                        y: -100,
                        scale: 1.5,
                        opacity: 0.7,
                      }}
                      whileInView={{
                        y: 0,
                        scale: 1,
                        opacity: 1,
                        transition: {
                          delay: 0.2,
                          duration: 2,
                          type: 'linear',
                        },
                      }}
                      transition={{
                        type: 'linear',
                      }}
                      viewport={{ once: true }}
                    >
                      <ContentTitle text={point.title} />
                    </motion.div>
                    <motion.div
                      initial={{
                        y: -100,
                        scale: 1,
                        opacity: 0,
                      }}
                      whileInView={{
                        y: 0,
                        scale: 1,
                        opacity: 1,
                        transition: {
                          delay: 0.2,
                          duration: 2,
                          type: 'linear',
                        },
                      }}
                      transition={{
                        type: 'linear',
                      }}
                      viewport={{ once: true }}
                    >
                      <ContentText text={point.content} />
                    </motion.div>
                  </div>
                  {i < 6 ? (
                    <motion.div
                      initial={{
                        y: 100,
                      }}
                      whileInView={{
                        y: 0,
                        transition: {
                          duration: 2,
                          type: 'linear',
                        },
                      }}
                      transition={{
                        type: 'linear',
                      }}
                      viewport={{ once: true }}
                      className={
                        'w-full place-items-center md:w-1/2 grid ' +
                        (i % 2 === 0 ? 'md:place-items-start' : 'md:place-items-end')
                      }
                    >
                      <Image
                        height={300}
                        width={200}
                        className={'w-[60%]  md:w-2/3 lg:w-1/3 rounded-2xl border-4 border-slate-600 '}
                        src={Crop.images[i]}
                        alt={point?.content}
                        sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
                      />
                    </motion.div>
                  ) : (
                    <></>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}

export async function getStaticPaths() {
  const ways = cropArray.map((it) => {
    return {
      params: { cropId: it.text },
    };
  });

  return {
    paths: ways,
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const id = params.cropId;
  let Crop = cropArray.find((it) => id === it.text) ?? {};
  return {
    props: { Crop, id },
  };
}
